// Campus photo for /colleges/georgetown-university: CC0 1.0, by Warren LeMay from Cincinnati, OH, United States, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AHealy_Hall%2C_Georgetown_University%2C_Georgetown%2C_Washington%2C_DC_(39641791973).jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/georgetown-university/; credited under the photo.
const photo = {
    "slug": "georgetown-university",
    "alt": "Healy Hall and its clock tower on the Georgetown University campus in Washington, DC, seen across the front lawn",
    "src": "/colleges/georgetown-university/campus-1600.webp",
    "srcSmall": "/colleges/georgetown-university/campus-800.webp",
    "srcMid": "/colleges/georgetown-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/georgetown-university/og.jpg",
    "title": "Healy Hall, Georgetown University, Georgetown, Washington, DC (39641791973)",
    "author": "Warren LeMay from Cincinnati, OH, United States",
    "license": "CC0 1.0",
    "licenseUrl": "https://creativecommons.org/publicdomain/zero/1.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AHealy_Hall%2C_Georgetown_University%2C_Georgetown%2C_Washington%2C_DC_(39641791973).jpg",
    "read": "2026-10-01"
};

export default photo;
